import {observer} from 'mobx-react';
import FormRow from '../../../../../forms/FormRow';
import FormColumn from '../../../../../forms/FormColumn';
import FormAutocompleteField from '../../../../../components/fields/FormAutocompleteField';

function FranchiseSubjectPanel({allowance, subsectionForm, readOnly = false}) {
    return (
        <FormColumn>
            <FormRow>
                <FormAutocompleteField
                    label="Franquicia"
                    form={subsectionForm}
                    fieldName="franchiseBrandId"
                    options={allowance.franchiseBrandOptions()}
                    readOnly={readOnly}
                />
            </FormRow>
        </FormColumn>
    );
}

export default observer(FranchiseSubjectPanel);
